import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Navbar from "../components/Navbar/Navbar";
import EditExpenseReportForm from "./EditExpenseReportForm";
import { apiCall } from "../api/apiCall";
import { ExpenseReport } from "../models/expense_report";
import TopHeader from "../components/Navbar/TopHeader";
import { getAuth, onAuthStateChanged } from "firebase/auth"; 
import { useEffect, useState } from "react";


function EditExpenseReportPage() {
  const { uuid } = useParams<{ uuid: string }>();

  const [isAuthReady, setIsAuthReady] = useState(false);
  useEffect(() => {
            const auth = getAuth(); 
            const unsubscribe = onAuthStateChanged(auth, (user) => {
              setIsAuthReady(true);
            });
            return () => unsubscribe();
          }, []);

  const {
    data: expenseReport,
    isLoading,
    isError,
    error,
  } = useQuery<ExpenseReport, Error>({
    queryKey: ["expense-report", uuid],
    queryFn: async () =>
      apiCall<ExpenseReport>(`/expense-reports/${uuid}`, { method: "GET" }),
    enabled: !!uuid && isAuthReady,
  });

  if (isLoading) {
    return (
      <>
        <Navbar />
         <TopHeader />
        <p style={{ paddingTop: "90px" }}>Loading expense report...</p>
      </>
    );
  }

  if (isError || !expenseReport) {
    return (
      <>
        <Navbar />
          <TopHeader />
        <p style={{ paddingTop: "90px", color: "red" }}>
          Error: {error?.message || "Expense report not found"}
        </p>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <p style={{ paddingLeft: "20px" }}></p>
                <TopHeader />
                

      <EditExpenseReportForm expenseReport={expenseReport} />
    </>
  );
}

export default EditExpenseReportPage;